/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Products_DescriptionInputs */



/**
* | output |
* | --- |
* | "Full card lists for official products" |
*
* @param {Nav_Products_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_products_description = /** @type {((inputs?: Nav_Products_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Products_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständige Kartenlisten offizieller Produkte")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Listes complètes des produits officiels")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("官方产品的完整卡牌列表")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("官方商品的完整卡表")
	if (locale === "ko") return /** @type {LocalizedString} */ ("공식 제품의 전체 카드 목록")
	return /** @type {LocalizedString} */ ("Full card lists for official products")
});